import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TrainedIcon from "../../../Assets/images/Programs/TrainedIcon.png";
import InContractsJobs from "../../../Assets/images/Programs/InContractsJobs.png";
import InFulltimeJob from "../../../Assets/images/Programs/InFulltimeJob.png";
import STEMExtension from "../../../Assets/images/Programs/STEMExtension.png";
import whatYouGet from "../../../Assets/images/Programs/whatYouGet.png";
import ProgramHighlightsBg from "../../../Assets/images/Programs/ProgramHighlightsBg.png";
import bullet from "../../../Assets/images/Programs/bullet-point 1.png";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import { Sparkles, Target, Users, TrendingUp, Zap, ArrowRight } from 'lucide-react';
import OutstandingFeatures from "./OutstandingFeatures";

const Highlights = [
  "Free Access to Exclusive Fulltime Placement Program.",
  "Interview Preparation, Coaching & Technical Mocks",
  "Post Interview and Marketing Gap Analysis",
  "Blended training based on Client’s Project requirements.",
  "Post training Evaluation and Re-Training facility.",
  "3 Days Workshop on 'How-To-Crack' interviews",
  "Hassel free switching of batch and skill during the training.",
  "Professional resume review by Tech Experts  ",
  "Post Placement On-Job Support",
  "Weekly assignment and evaluation on real time case studies.",
];

const ChooseUs = [
  {
    title: "Global Recognition",
    para: "With over 5 years of experience, we have a solid track record of successfully transitioning individuals from non-IT backgrounds into the IT domain, creating global professionals.",
  },
  {
    title: "Industry-Driven Curriculum",
    para: "Our programs are developed in collaboration with industry leaders, ensuring they are aligned with current market demands and equipped with practical skills.",
  },
  {
    title: "Proven Career Success",
    para: "Our alumni secure graduate-level employment three times faster than industry averages, with 92% finding jobs during or within three months of completing the program.",
  },
  {
    title: "Experienced Faculty",
    para: "Learn from seasoned industry professionals who provide mentorship and guidance based on real-world insights and experiences.",
  },
  {
    title: "High Starting Salaries",
    para: "Participants typically earn starting salaries that are 30% higher than their peers, reflecting the quality and relevance of our training.",
  },
  {
    title: "Comprehensive Support",
    para: "Enjoy personalized career coaching, interview preparation, and continuous learning opportunities to enhance your professional growth and competitiveness in the IT industry.",
  },
  {
    title: "E-verify and H1B Support",
    para: "As an E-verify and H1B dependent employer, we provide seamless support for international professionals seeking to build careers in the United States.",
  },
  {
    title: "Transparent Policies",
    para: "Emphasize your transparent approach to business operations, including clear policies on refunds, guarantees, and terms of service that demonstrate your commitment to integrity and customer satisfaction.",
  },
];

const features = [
  { icon: Target, title: "Real-World Experience", desc: "Industry-validated skills" },
  { icon: Users, title: "Direct Connections", desc: "Network with employers" },
  { icon: TrendingUp, title: "Career Intelligence", desc: "Strategic career moves" }
];

const stats = [
  { number: "10K+", label: "Success Stories" },
  { number: "95%", label: "Placement Rate" },
  { number: "500+", label: "Partner Companies" }
];

const RemoteBootCamp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeCard, setActiveCard] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setActiveCard(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  return (
    <div>
      <div>
        {/* Boost Your Job Hunt */}
        <div className="relative min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 overflow-hidden pt-14">
          {/* Animated Background Elements */}
          <div className="absolute inset-0">
            <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-conic from-orange-500/5 via-purple-500/5 to-orange-500/5 rounded-full blur-3xl animate-spin" style={{ animationDuration: '20s' }}></div>
          </div>
          {/* Floating Particles */}
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-orange-400/30 rounded-full animate-bounce"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${2 + Math.random() * 3}s`
              }}
            ></div>
          ))}

          <div className="relative z-10 flex items-center min-h-screen p-8" onMouseMove={handleMouseMove}>
            <div className={`max-w-7xl mx-auto w-full transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>

              {/* Main Content Grid */}
              <div className="grid lg:grid-cols-2 gap-12 items-center">

                {/* Left Content */}
                <div className="space-y-8">
                  {/* Header Badge */}
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/20 backdrop-blur-sm border border-orange-500/30 rounded-full text-orange-300 text-sm font-medium">
                    <Sparkles className="w-4 h-4" />
                    <span className="font-mono tracking-wider">Career Enhancer</span>
                    <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></div>
                  </div>
                  {/* Main Title */}
                  <div className="space-y-4">
                    <h1 className="text-6xl lg:text-7xl font-black leading-none text-white">
                      Boost Your{" "}
                      <span className="relative">
                        <span className="bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 bg-clip-text text-transparent animate-pulse">
                          Job Hunt
                        </span>
                        <div className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-orange-400 to-pink-500 rounded-full animate-pulse"></div>
                      </span>
                    </h1>
                    {/* Animated subtitle */}
                    <div className="flex items-center gap-3 text-2xl text-gray-300">
                      <Zap className="w-6 h-6 text-orange-400 animate-bounce" />
                      <span className="font-light">Transform Your Career Today</span>
                    </div>
                  </div>

                  {/* Description with Glassmorphism */}
                  <div className="space-y-6 p-6 bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl">
                    <p className="text-lg text-gray-300 leading-relaxed">
                      Access exclusive training programs designed for{" "}
                      <span className="text-orange-400 font-semibold">fresh graduates</span>,{" "}
                      <span className="text-purple-400 font-semibold">experienced professionals</span>, and{" "}
                      <span className="text-pink-400 font-semibold">career switchers</span>.
                    </p>

                    <p className="text-gray-400 leading-relaxed">
                      Get job-oriented practical training from industry experts and land your dream technology
                      job in leading IT companies. Our originality lies in real-world experience and skills
                      that employers actually value.
                    </p>
                  </div>

                  {/* Feature Cards */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {features.map((feature, index) => (
                      <div
                        key={index}
                        className={`group p-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 cursor-pointer transform hover:-translate-y-1 ${activeCard === index ? 'ring-2 ring-orange-400/50 bg-orange-500/10' : ''}`}
                        onMouseEnter={() => setActiveCard(index)}
                      >
                        <feature.icon className={`w-8 h-8 mb-2 transition-colors duration-300 ${activeCard === index ? 'text-orange-400' : 'text-gray-400 group-hover:text-white'}`} />
                        <h3 className="font-semibold text-white text-sm mb-1">{feature.title}</h3>
                        <p className="text-xs text-gray-400">{feature.desc}</p>
                      </div>
                    ))}
                  </div>

                  {/* CTA Button */}
                  <div className="flex items-center gap-4">
                    <button className="group relative px-8 py-4 bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold rounded-2xl shadow-2xl hover:shadow-orange-500/25 transition-all duration-300 transform hover:scale-105 hover:-translate-y-1">
                      <span className="flex items-center gap-2">
                        Start Your Journey
                        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                      </span>
                      <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-red-700 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
                    </button>

                    <div className="flex items-center gap-2 text-sm text-gray-400">
                      <div className="flex -space-x-2">
                        {[...Array(3)].map((_, i) => (
                          <div key={i} className="w-8 h-8 bg-gradient-to-br from-orange-400 to-red-500 rounded-full border-2 border-slate-900"></div>
                        ))}
                      </div>
                      <span>Join over 1K+ professionals</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Outstanding Features */}
      {/* <div className="">
        <div className="lg:px-20 md:px-10 px-5 tracking-wide">
          <h1 className="text-3xl font-medium text-end">
            Outstanding Features
          </h1>
          <div className="flex justify-end">
            <div className="h-1 bg-gradient-to-l from-red-500 to-white w-[25%]"></div>
          </div>
        </div>
        <div
          style={{
            backgroundImage: `url(${outstandingFeatures_bg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          className="border mt-8 grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:px-20 md:px-10 px-5 pt-5 pb-10 gap-2"
        >
          <div className="flex flex-col lg:gap-8 gap-2 ">
            {OutstandingFeatures.slice(0, 2).map((ele, ind) => (
              <div
                key={ind}
                className="flex flex-col gap-2 bg-white px-5 py-10 rounded-lg lg:border-none border border-gray-300"
              >
                <img src={ele?.icon} alt={ele?.heading} className="w-20" />
                <h1 className="font-medium text-xl tracking-wide">
                  {ele?.heading}
                </h1>
                <p className="text-secondaryTextColor tracking-wider text-justify">
                  {ele?.para}
                </p>
              </div>
            ))}
          </div>
          <div className=" flex flex-col lg:gap-8 gap-2 lg:mt-20">
            {OutstandingFeatures.slice(2, 4).map((ele, ind) => (
              <div
                key={ind}
                className="flex flex-col gap-2 bg-white px-5 py-10 rounded-lg lg:border-none border border-gray-300"
              >
                <img src={ele?.icon} alt={ele?.heading} className="w-20" />
                <h1 className="font-medium text-xl tracking-wide">
                  {ele?.heading}
                </h1>
                <p className="text-secondaryTextColor tracking-wider text-justify">
                  {ele?.para}
                </p>
              </div>
            ))}
          </div>
          <div className=" flex flex-col lg:gap-8 gap-2 ">
            {OutstandingFeatures.slice(4, 6).map((ele) => (
              <div className="flex flex-col gap-2 bg-white px-5 py-10 rounded-lg">
                <img src={ele?.icon} alt={ele?.heading} className="w-20" />
                <h1 className="font-medium text-xl tracking-wide">
                  {ele?.heading}
                </h1>
                <p className="text-secondaryTextColor tracking-wider text-justify">
                  {ele?.para}
                </p>
              </div>
            ))}
          </div>
          <div className=" flex flex-col lg:gap-8 gap-2  lg:mt-20">
            {OutstandingFeatures.slice(6, 8).map((ele) => (
              <div className="flex flex-col gap-2 bg-white px-5 py-10 rounded-lg ">
                <img src={ele?.icon} alt={ele?.heading} className="w-20" />
                <h1 className="font-medium text-xl tracking-wide">
                  {ele?.heading}
                </h1>
                <p className="text-secondaryTextColor tracking-wider text-justify">
                  {ele?.para}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      <OutstandingFeatures />
      <div className="lg:px-20 md:px-10 px-5 py-10">
        {/* Count Section */}
        <div className="grid lg:grid-cols-4 grid-cols-2 gap-8 pb-8">
          <div className="text-center">
            <img src={TrainedIcon} alt="TrainedIcon" className="m-auto" />
            <h1 className="font-bold text-3xl">3000+</h1>
            <p className="mt-1">Trained</p>
          </div>
          <div className="text-center">
            <img
              src={InContractsJobs}
              alt="TrainedIcon"
              className="m-auto"
            />
            <h1 className="font-bold text-3xl">3000+</h1>
            <p className="mt-1">In Contracts Jobs</p>
          </div>
          <div className="text-center">
            <img src={InFulltimeJob} alt="TrainedIcon" className="m-auto" />
            <h1 className="font-bold text-3xl">3000+</h1>
            <p className="mt-1">In Fulltime Job</p>
          </div>
          <div className="text-center">
            <img src={STEMExtension} alt="TrainedIcon" className="m-auto" />
            <h1 className="font-bold text-3xl">3000+</h1>
            <p className="mt-1">STEM Extension   </p>
          </div>
        </div>
        {/* What You Get From Us ! */}
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
          <div className="flex items-center">
            <div className="flex flex-col gap-2 tracking-wider ">
              <h1 className="md:text-3xl text-xl font-medium">
                What You Get
                <b className="text-primaryOrangeColor"> From Us </b>!
              </h1>
              <p className="text-justify">
                He Independent Internship Program is our 8-10 week
                internship program. It takes place year-round and is
                designed to have current or recent graduates work on an
                internship from any location. Graduates of the program gain
                the professional skills, experience and connections
                necessary to launch a successful career.
              </p>
            </div>
          </div>
          <div className="flex justify-end items-center">
            <img
              src={whatYouGet}
              alt="BoostYourJobHunt"
              className="w-[80%]"
            />
          </div>
        </div>
      </div>
      {/* Program Highlights */}
      <div
        style={{
          backgroundImage: `url(${ProgramHighlightsBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
        className="h-auto lg:px-20 md:px-10 px-5 py-10 tracking-wider"
      >
        <h1 className="md:text-4xl text-2xl text-center text-white">
          Program <span className="text-primaryDarkColor">Highlights</span>
        </h1>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 mt-10">
          {Highlights?.map((ele) => (
            <div className="flex gap-2">
              <div className="w-[5%]">
                <img src={bullet} alt="bullet" className="w-6 mt-[5px]" />
              </div>
              <p className="text-white text-lg w-[95%]">{ele}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Choose Your Plan Wisely */}
      <div className="lg:px-20 md:px-10 px-5 py-20 bg-gradient-to-br from-slate-50 via-white to-blue-50 relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] pointer-events-none"></div>
        <div className="absolute top-10 left-10 w-72 h-72 bg-primaryOrangeColor/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>

        {/* Header Section */}
        <div className="relative z-10 mb-16">
          <h1 className="text-4xl lg:text-5xl text-center font-bold bg-gradient-to-r from-primaryDarkColor via-primaryOrangeColor to-primaryDarkColor bg-clip-text text-transparent leading-tight">
            Choose Your{" "}
            <span className="relative text-green-800">
              Plan
              <svg className="absolute -bottom-2 left-0 w-full h-3 text-primaryOrangeColor/30" viewBox="0 0 100 10" preserveAspectRatio="none">
                <path d="M0,8 Q50,0 100,8" stroke="currentColor" strokeWidth="2" fill="none" />
              </svg>
            </span>{" "}
            Wisely
          </h1>
          <p className="text-center max-w-2xl mx-auto mt-6 mb-12 text-lg text-secondaryTextColor leading-relaxed font-medium">
            Each plan is thoughtfully designed to meet different levels of need—so you can select the one that aligns perfectly with your requirements.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 max-w-7xl mx-auto relative z-10">

          {/* Growth Plan Card */}
          <div className="group relative">
            {/* Floating decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-r from-green-400/20 to-green-500/20 rounded-full blur-xl animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-green-500/10 rounded-full animate-bounce"></div>

            <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl shadow-slate-900/5 border border-slate-200/50 p-8 h-full flex flex-col hover:shadow-2xl hover:shadow-green-500/10 transition-all duration-500 hover:-translate-y-2 group-hover:bg-white/90 relative overflow-hidden">
              {/* Card header */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-green-400 to-green-500 flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-primaryDarkColor">Growth</h3>
                    <p className="text-sm text-green-600 font-medium">Starter Plan</p>
                  </div>
                </div>
                <div className="px-3 py-1 bg-green-100 text-green-800 text-xs font-semibold rounded-full">POPULAR</div>
              </div>

              {/* Price */}
              <div className="mb-6">
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-primaryDarkColor">$1099</span>
                  <span className="text-secondaryTextColor">/month</span>
                </div>
                <p className="text-sm text-secondaryTextColor mt-1">30 days support included</p>
              </div>

              {/* Features */}
              <div className="flex-1 mb-8">
                <p className="font-semibold text-primaryDarkColor mb-3">Perfect for:</p>
                <p className="text-secondaryTextColors text-sm mb-4 leading-relaxed">
                  International students, recent graduates, or early-career professionals looking to enter the U.S. tech market.
                </p>

                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">Personalized training & upskilling</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">Behavioral grooming & resume support</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors"><strong>500+ job submissions</strong></span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">Direct hiring manager outreach</span>
                  </li>
                </ul>
              </div>

              {/* CTA Button */}
              <button className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-xl font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-green-500/25 hover:-translate-y-0.5">
                Get Started
              </button>
            </div>
          </div>

          {/* Professional Plan Card */}
          <div className="group relative lg:scale-105 lg:z-10">
            {/* Floating decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-r from-primaryOrangeColor/20 to-orange-500/20 rounded-full blur-xl animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-primaryOrangeColor/10 rounded-full animate-bounce"></div>

            {/* Most Popular Badge */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
              <div className="bg-gradient-to-r from-primaryOrangeColor to-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                MOST POPULAR
              </div>
            </div>

            <div className="bg-white backdrop-blur-sm rounded-3xl shadow-2xl shadow-primaryOrangeColor/10 border-2 border-primaryOrangeColor/20 p-8 h-full flex flex-col hover:shadow-2xl hover:shadow-primaryOrangeColor/20 transition-all duration-500 hover:-translate-y-2 relative overflow-hidden">
              {/* Card header */}
              <div className="flex items-center justify-between mb-6 mt-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primaryOrangeColor to-orange-500 flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-primaryDarkColor">Professional</h3>
                    <p className="text-sm text-primaryOrangeColor font-medium">Advanced Plan</p>
                  </div>
                </div>
              </div>

              {/* Price */}
              <div className="mb-6">
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-primaryDarkColor">$1499</span>
                  <span className="text-secondaryTextColor">/month</span>
                </div>
                <p className="text-sm text-secondaryTextColor mt-1">60 days aggressive support</p>
              </div>

              {/* Features */}
              <div className="flex-1 mb-8">
                <p className="font-semibold text-primaryDarkColor mb-3">Perfect for:</p>
                <p className="text-secondaryTextColors text-sm mb-4 leading-relaxed">
                  Candidates with some training or experience who are ready to secure a full-time tech position quickly and confidently.
                </p>

                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-primaryOrangeColor mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">Hands-on mentorship & advanced prep</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-primaryOrangeColor mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">Project-based experience</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-primaryOrangeColor mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors"><strong>1000+ job submissions</strong></span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-primaryOrangeColor mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">High-impact hiring team outreach</span>
                  </li>
                </ul>
              </div>

              {/* CTA Button */}
              <button className="w-full bg-gradient-to-r from-primaryOrangeColor to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white py-4 rounded-xl font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-primaryOrangeColor/25 hover:-translate-y-0.5">
                Choose Professional
              </button>
            </div>
          </div>

          {/* Switch Plan Card */}
          <div className="group relative">
            {/* Floating decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-r from-purple-400/20 to-purple-500/20 rounded-full blur-xl animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-purple-500/10 rounded-full animate-bounce"></div>

            <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl shadow-slate-900/5 border border-slate-200/50 p-8 h-full flex flex-col hover:shadow-2xl hover:shadow-purple-500/10 transition-all duration-500 hover:-translate-y-2 group-hover:bg-white/90 relative overflow-hidden">
              {/* Card header */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-primaryDarkColor">Switch</h3>
                    <p className="text-sm text-purple-600 font-medium">Premium Plan</p>
                  </div>
                </div>
                <div className="px-3 py-1 bg-purple-100 text-purple-800 text-xs font-semibold rounded-full">ENTERPRISE</div>
              </div>

              {/* Price */}
              <div className="mb-6">
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-primaryDarkColor">$1799</span>
                  <span className="text-secondaryTextColor">/month</span>
                </div>
                <p className="text-sm text-secondaryTextColor mt-1">90 days comprehensive support</p>
              </div>

              {/* Features */}
              <div className="flex-1 mb-8">
                <p className="font-semibold text-primaryDarkColor mb-3">Perfect for:</p>
                <p className="text-secondaryTextColors text-sm mb-4 leading-relaxed">
                  Working professionals seeking a domain change, higher pay, or visa sponsorship without risking their current job.
                </p>

                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-purple-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">Expert-led career transitioning</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-purple-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">End-to-end project work</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-purple-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors"><strong>2000+ job applications</strong></span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-purple-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-secondaryTextColors">600 direct hiring manager emails</span>
                  </li>
                </ul>
              </div>

              {/* CTA Button */}
              <button className="w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white py-4 rounded-xl font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/25 hover:-translate-y-0.5">
                Switch Now
              </button>
            </div>
          </div>
        </div>

        {/* Enhanced CTA Section */}
        <div className="text-center mt-16 relative z-10">
          <div className="inline-block">
            <Link
              to="/courses"
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-primaryOrangeColor to-orange-400 hover:from-primaryDarkColor hover:to-slate-700 text-white px-10 py-4 rounded-full font-semibold text-lg shadow-lg shadow-primaryOrangeColor/30 hover:shadow-primaryDarkColor/30 transition-all duration-500 hover:-translate-y-1 hover:scale-105"
            >
              <span>Explore All Courses</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </Link>
          </div>
          <p className="mt-4 text-secondaryTextColor text-sm">All plans include comprehensive support and job placement assistance</p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="lg:px-20 md:px-10 px-5 py-10">
        <h1 className="text-3xl text-center font-medium">
          Why <span className="text-primaryOrangeColor">Choose</span> Us
        </h1>
        <p className="tracking-wider w-[70%] m-auto mt-2 text-secondaryTextColor text-justify">
          At Techmentee, we specialize in helping international students and IT & Non-IT professionals land full-time roles in the U.S. job market. Our tailored support includes one on one  technical training, personalized resume review, one-on-one interview prep, and direct marketing to top recruiters. With our expert guidance and vast employer network, we don’t just prepare you — we position you to get hired
        </p>
        <div className="grid lg:grid-cols-2 grid-cols-1 mt-8 gap-8">
          {ChooseUs?.map((ele, ind) => (
            <div key={ind} className="flex">
              <div
                className={`w-[2%] h-full ${(ind === 0 || ind === 3 || ind === 4 || ind === 7) &&
                  "bg-primaryOrangeColor"
                  } ${(ind === 1 || ind === 2 || ind === 5 || ind === 6) &&
                  "bg-gray-500"
                  } `}
              ></div>
              <div className="w-[98%] h-full p-4">
                <h1 className="font-bold text-lg">{ele.title}</h1>
                <p className="tracking-wider text-secondaryTextColor text-justify">
                  {ele?.para}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:px-20 md:px-10 px-5 py-10">
        <GetInTouchUs />
      </div>
    </div>
  );
};

export default RemoteBootCamp;
